class TemplateProductJS {
  constructor() {
    this.container = document.querySelector('[data-product-container]');
    this.init();
  }

  /** Show Buy it now only when the selected variant is available (hides entirely when sold out). */
  syncBuyNowWithVariant(variant) {
    const wrap = this.container?.querySelector('[data-product-buy-now-wrap]');
    if (!wrap) return;

    const btn = wrap.querySelector('[data-product-buy-now]');
    const buyLabel = window.variantStrings?.buyItNow || 'Buy it now';
    const textEl = wrap.querySelector('.product-buy-now__text');

    const show = Boolean(variant && variant.available);
    wrap.classList.toggle('d-none', !show);

    if (!show || !btn) return;

    btn.removeAttribute('disabled');
    if (textEl) textEl.textContent = buyLabel;
  }

  init(){
     // Product page variant change event to update dynamic data
     eventBus.subscribe(THEME_EVENTS.variantChange, (eventData) => {
      const { container, variant, html } = eventData.data;
      const activeContainer = container || this.container;
      if (activeContainer) this.container = activeContainer;

      this.handleUpdateProductInfo(html);
      this.handleVariantFieldVisibility(activeContainer, variant);
      this.syncBuyNowWithVariant(variant);
      if (typeof window.ffm_reinitializeTrustpilotTrustBoxes === 'function') {
        window.ffm_reinitializeTrustpilotTrustBoxes(activeContainer, variant);
      }
    });

    document.addEventListener('product:content:updated', (event) => {
      const { document: nextDocument, variant, container } = event.detail || {};
      if (container) this.container = document.querySelector('[data-product-container]') || container;
      if (nextDocument) this.handleUpdateProductInfo(nextDocument);
      if (variant) this.syncBuyNowWithVariant(variant);
      if (typeof window.ffm_reinitializeTrustpilotTrustBoxes === 'function') {
        const scope = document.querySelector('#MainProductContent') || this.container;
        window.ffm_reinitializeTrustpilotTrustBoxes(scope, variant);
      }
    });
  }

  handleUpdateProductInfo(html){
    if (!html) return;

    const container = this.container || document.querySelector('[data-product-container]');
    if (!container) return;

    const productId = container.dataset.product;

    Utility.updateSourceFromDestination(`#Inventory-${productId}`, html, container);
    Utility.updateSourceFromDestination(`#Sku-${productId}`, html, container);
    Utility.updateSourceFromDestination(`#Quantity-${productId}`, html, container);
    Utility.updateSourceFromDestination(`#Volume-discount-${productId}`, html, container);
    this.syncProductDescriptions(html);
  }

  syncProductDescriptions(html) {
    const sources = html.querySelectorAll('[data-product-description]');
    const destinations = document.querySelectorAll('[data-product-description]');
    destinations.forEach((destination, index) => {
      const source = sources[index];
      if (source) destination.innerHTML = source.innerHTML;
    });
  }

  /**
   * Show/hide variant-specific fields (e.g. product size info, secondary size description)
   * so the correct message is shown for the selected variant (e.g. size + number of lobsters).
   */
  handleVariantFieldVisibility(container, variant) {
    if (!container || !variant) return;
    const variantId = variant.id;
    container.querySelectorAll('.__ffm_variant_field').forEach((el) => {
      const display = el.dataset.display || 'block';
      el.style.display = Number(el.dataset.variant) === variantId ? display : 'none';
    });
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();

// Sticky Add to Cart Bar functionality
(function() {
  let scrollHandler = null;
  let stickyButtonClickHandler = null;
  let stickyBar = null;
  let addToCartButton = null;
  let stickyButton = null;
  let ticking = false;

  function isButtonScrolledPast() {
    if (!addToCartButton) return false;
    return addToCartButton.getBoundingClientRect().top < 0;
  }

  function handleScroll() {
    if (!stickyBar) return;

    if (isButtonScrolledPast()) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  function destroyProductStickyBar() {
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }

    if (stickyButton && stickyButtonClickHandler) {
      stickyButton.removeEventListener('click', stickyButtonClickHandler);
    }

    stickyBar?.classList.remove('visible');

    stickyBar = null;
    addToCartButton = null;
    stickyButton = null;
    stickyButtonClickHandler = null;
    ticking = false;
  }

  function initProductStickyBar() {
    destroyProductStickyBar();

    stickyBar = document.querySelector('[data-product-sticky-bar]');
    const productForm = document.querySelector('.product-form');
    addToCartButton = productForm ? productForm.querySelector('button[type="submit"][name="add"]') : null;

    if (!stickyBar || !addToCartButton) return;

    scrollHandler = onScroll;
    window.addEventListener('scroll', scrollHandler, { passive: true });
    handleScroll();

    stickyButton = stickyBar.querySelector('a[href="#product-form"]');
    if (!stickyButton) return;

    stickyButtonClickHandler = function(e) {
      const productFormEl = document.getElementById('product-form');
      const siteHeader = document.querySelector('.site-header');

      if (!productFormEl) return;

      e.preventDefault();

      let headerHeight = 0;
      if (siteHeader) headerHeight = siteHeader.offsetHeight;

      const elementPosition = productFormEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    };

    stickyButton.addEventListener('click', stickyButtonClickHandler);
  }

  window.reinitializeProductStickyBar = initProductStickyBar;
  initProductStickyBar();
  document.addEventListener('product:content:updated', initProductStickyBar);
})();

// Swym wishlist — inject + reinitialize after combined-listing swaps (innerHTML removes app embed)
(function() {
  const PDP_SCOPE = '[data-product-container]';
  const MAIN_CONTENT = '#MainProductContent';

  let mutationObserver = null;
  let swymBarTemplate = null;
  let swymAddLabel = 'Add to Fishlist';
  let swymRemoveLabel = 'Remove from Fishlist';
  let swymAddCtaText = 'Add to Fishlist';
  let swymAddedCtaText = 'Added';
  let swymPassRunning = false;
  let swymReinitTimer = null;
  let lastSwymContextKey = '';

  function getSwat() {
    return window._swat || null;
  }

  function isGiftProductPage() {
    return document.body?.hasAttribute('data-gift-template');
  }

  function centsToSwymPrice(cents) {
    if (cents == null || Number.isNaN(Number(cents))) return 0;
    return Number(cents) / 100;
  }

  function resolveVariant(product, variant) {
    if (variant?.id && (variant.price != null || !product?.variants)) return variant;
    const id = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value;
    if (!id) return variant || null;
    if (product?.variants) {
      return product.variants.find(function(v) { return String(v.id) === String(id); }) || variant || null;
    }
    return variant?.id ? variant : (id ? { id: Number(id) } : null);
  }

  function resolveImage(product, variant) {
    return variant?.featured_image?.src
      || variant?.image
      || (typeof product?.featured_image === 'string' ? product.featured_image : '')
      || '';
  }

  function absoluteShopifyUrl(url) {
    if (!url) return window.location.href;
    if (/^https?:\/\//i.test(url)) return url;
    if (url.startsWith('//')) return window.location.protocol + url;
    const path = url.startsWith('/') ? url : '/' + url;
    return window.location.origin + path;
  }

  function buildProductPayload(product, variant) {
    variant = resolveVariant(product, variant);
    if (!product || !variant?.id) return null;

    const productPath = product.url || window.location.pathname;

    return {
      empi: product.id,
      epi: variant.id,
      du: absoluteShopifyUrl(productPath),
      dt: product.title,
      iu: absoluteShopifyUrl(resolveImage(product, variant)),
      pr: centsToSwymPrice(variant.price)
    };
  }

  function updateSwymPageData(product, variant) {
    const payload = buildProductPayload(product, variant);
    if (!payload) return;

    window.SwymPageData = Object.assign({ et: 1 }, payload);

    if (product?.variants?.length) {
      const map = {};
      const fallbackImage = resolveImage(product, variant);
      product.variants.forEach(function(v) {
        map[v.id] = {
          epi: v.id,
          pr: centsToSwymPrice(v.price),
          iu: resolveImage(product, v) || fallbackImage,
          stk: v.available
        };
      });
      window.SwymProductVariants = map;
    }
  }

  function getProductFormElement() {
    return document.querySelector('.product-form');
  }

  function findNativeSwymButtonBar() {
    const bars = document.querySelectorAll('.swym-button-bar');
    for (let i = 0; i < bars.length; i += 1) {
      if (!bars[i].hasAttribute('data-ffm-swym-injected')) return bars[i];
    }
    return null;
  }

  function findSwymButtonBar() {
    return document.querySelector(PDP_SCOPE + ' .swym-button-bar')
      || document.querySelector('.product-form-list .swym-button-bar')
      || document.querySelector(MAIN_CONTENT + ' .swym-button-bar');
  }

  function isSwymBarPlacedCorrectly(productFormElement, bar) {
    return Boolean(productFormElement && bar && productFormElement.nextElementSibling === bar);
  }

  function moveSwymButtonBarOutsideForm() {
    const productFormElement = getProductFormElement();
    if (!productFormElement) return false;

    const bar = findSwymButtonBar();
    if (!bar) return false;

    if (!isSwymBarPlacedCorrectly(productFormElement, bar)) {
      productFormElement.insertAdjacentElement('afterend', bar);
      bar.classList.add('moved');
    }

    bar.style.display = 'block';
    return true;
  }

  function startSwymPlacementWatcher() {
    moveSwymButtonBarOutsideForm();

    if (window.__ffmSwymPlacementInterval) return;

    let attempts = 0;
    window.__ffmSwymPlacementInterval = setInterval(function() {
      const moved = moveSwymButtonBarOutsideForm();
      if (moved) captureSwymBarTemplate();

      const productFormElement = getProductFormElement();
      const bar = findSwymButtonBar();
      if (isSwymBarPlacedCorrectly(productFormElement, bar) || ++attempts >= 50) {
        clearInterval(window.__ffmSwymPlacementInterval);
        window.__ffmSwymPlacementInterval = null;
      }
    }, 250);
  }

  function captureSwymBarTemplate() {
    const nativeBar = findNativeSwymButtonBar();
    if (!nativeBar) return;

    const nativeBtn = nativeBar.querySelector('button');
    const nativeCta = nativeBtn?.querySelector('.swym-wishlist-cta');
    if (nativeBtn?.getAttribute('aria-label')) {
      swymAddLabel = nativeBtn.getAttribute('aria-label');
      swymRemoveLabel = swymAddLabel.replace(/^Add to /i, 'Remove from ');
    }
    if (nativeCta?.textContent) {
      if (nativeBtn.classList.contains('swym-added')) {
        swymAddedCtaText = nativeCta.textContent.trim() || swymAddedCtaText;
      } else {
        swymAddCtaText = nativeCta.textContent.trim() || swymAddLabel;
      }
    }

    swymBarTemplate = nativeBar.cloneNode(true);
    window.__ffmSwymBarTemplate = swymBarTemplate.cloneNode(true);
    swymBarTemplate.removeAttribute('style');
    swymBarTemplate.classList.remove('moved');

    const templateBtn = swymBarTemplate.querySelector('button');
    if (templateBtn) {
      templateBtn.removeAttribute('data-variant-id');
      templateBtn.removeAttribute('data-product-id');
      templateBtn.removeAttribute('data-product-url');
      templateBtn.removeAttribute('data-ffm-swym-wired');
      templateBtn.removeAttribute('onclick');
      templateBtn.classList.remove('swym-added', 'swym-loaded', 'disabled');
      const templateCta = templateBtn.querySelector('.swym-wishlist-cta');
      if (templateCta) templateCta.textContent = swymAddCtaText;
    }
  }

  function updateButtonState(btn, isWishlisted) {
    if (!btn) return;
    const cta = btn.querySelector('.swym-wishlist-cta');

    if (isWishlisted) {
      btn.classList.add('swym-added', 'disabled', 'swym-loaded');
      btn.setAttribute('aria-label', swymRemoveLabel);
      if (cta) cta.textContent = swymAddedCtaText;
    } else {
      btn.classList.remove('swym-added', 'disabled');
      btn.classList.add('swym-loaded');
      btn.setAttribute('aria-label', swymAddLabel);
      if (cta) cta.textContent = swymAddCtaText;
    }
  }

  function productPathFromUrl(url) {
    if (!url) return window.location.pathname;
    try {
      if (/^https?:\/\//i.test(url)) return new URL(url).pathname;
    } catch (_) {}
    return url.startsWith('/') ? url : '/' + url;
  }

  function normalizeSwymProduct(payload) {
    return {
      empi: Number(payload.empi),
      epi: Number(payload.epi),
      du: absoluteShopifyUrl(payload.du),
      dt: payload.dt || '',
      iu: absoluteShopifyUrl(payload.iu),
      pr: Number(payload.pr) || 0
    };
  }

  function resolveSwymProduct(swat, payload, variantId, callback) {
    const normalized = normalizeSwymProduct(payload);
    const selectedEpi = Number(variantId || normalized.epi);

    if (typeof swat.getProductDetails !== 'function') {
      callback(Object.assign({}, normalized, { epi: selectedEpi }));
      return;
    }

    swat.getProductDetails({ du: productPathFromUrl(normalized.du) }, function(details) {
      if (!details) {
        callback(Object.assign({}, normalized, { epi: selectedEpi }));
        return;
      }

      const variantInfo = window.SwymProductVariants?.[selectedEpi];

      callback({
        empi: Number(details.empi || details.id || normalized.empi),
        epi: selectedEpi,
        du: absoluteShopifyUrl(details.du || normalized.du),
        dt: details.dt || details.title || normalized.dt,
        iu: absoluteShopifyUrl(variantInfo?.iu || details.iu || normalized.iu),
        pr: variantInfo?.pr != null ? Number(variantInfo.pr) : (details.pr != null ? Number(details.pr) : normalized.pr)
      });
    });
  }

  function buildSwymWishlistNotificationMessage(swat, data) {
    const settings = swat.settings || swat.ui?.uiRef?.settings || {};
    const strings = settings.Strings || {};
    const uiSettings = settings.UI || {};
    const template = strings.AddWishlistAddSuccess || '{variantName} has been added to your Wishlist!';

    const variantInfo = data.vi || '';
    let variantName = data.dt || '';
    if (variantInfo && uiSettings.ShowVariantTitle) {
      variantName += ' - ' + variantInfo;
    }

    if (typeof uiSettings.RenderString === 'function') {
      try {
        return uiSettings.RenderString(template, { variantName: variantName });
      } catch (_) {}
    }

    return template.replace(/\{variantName\}/g, variantName);
  }

  function enrichSwymNotificationData(data) {
    if (!data || data.vi || !data.epi) return data;

    const variant = window.globalSpace?.product?.variants?.find(function(v) {
      return String(v.id) === String(data.epi);
    });

    if (variant?.title && variant.title !== 'Default Title') {
      return Object.assign({}, data, { vi: variant.title });
    }

    return data;
  }

  function notifySwymWishlistAdded(swat, product, addedItem) {
    if (!swat || !product) return;

    let data = (addedItem && typeof addedItem === 'object')
      ? Object.assign({}, product, addedItem)
      : Object.assign({}, product);
    data = enrichSwymNotificationData(data);

    if (swat.evtLayer) {
      const eventName = (swat.JSEvents && swat.JSEvents.addedToWishlist) || 'sw:addedtowishlist';
      try {
        swat.evtLayer.dispatchEvent(new CustomEvent(eventName, { detail: { d: data } }));
      } catch (_) {}
    }

    const uiRef = swat.ui?.uiRef;
    if (typeof uiRef?.showNotification !== 'function') return;

    const openFromNotification = swat.Instrumentations?.UIOpenFromNotification;

    try {
      uiRef.showNotification({
        image: data.iu || '',
        message: buildSwymWishlistNotificationMessage(swat, data),
        epi: data.epi,
        empi: data.empi,
        onClick: function() {
          if (typeof swat.ui?.open === 'function') {
            swat.ui.open(openFromNotification != null ? { originInstrument: openFromNotification } : undefined);
          }
        }
      });
    } catch (_) {}
  }

  function handleInjectedWishlistClick(swat, bar, btn) {
    const payload = bar._ffmSwymProduct;
    if (!payload || !swat) return;

    const variantId = btn.getAttribute('data-variant-id');

    resolveSwymProduct(swat, payload, variantId, function(product) {
      bar._ffmSwymProduct = product;

      if (btn.classList.contains('swym-added')) {
        swat.removeFromWishList(product, function() {
          updateButtonState(btn, false);
        });
      } else {
        swat.addToWishList(product, function(addedItem) {
          updateButtonState(btn, true);
          notifySwymWishlistAdded(swat, product, addedItem);
        });
      }
    });
  }

  function bindInjectedWishlistClicks() {
    if (window.__ffmSwymDelegatedClick) return;
    window.__ffmSwymDelegatedClick = true;

    document.addEventListener('click', function(event) {
      const bar = event.target.closest('.swym-button-bar[data-ffm-swym-injected]');
      if (!bar) return;

      const btn = event.target.closest('button');
      if (!btn || !bar.contains(btn)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      withSwat(function(swat) {
        handleInjectedWishlistClick(swat, bar, btn);
      });
    }, true);
  }

  function checkWishlistState(swat, btn, payload) {
    if (!btn || !payload) return;

    if (!swat?.fetch) {
      updateButtonState(btn, false);
      return;
    }

    swat.fetch(function(wishlisted) {
      const found = (wishlisted || []).some(function(item) {
        return String(item.empi) === String(payload.empi) && String(item.epi) === String(payload.epi);
      });
      updateButtonState(btn, found);
    });
  }

  function wireWishlistButton() {
    bindInjectedWishlistClicks();
  }

  function createSwymButtonBar() {
    captureSwymBarTemplate();

    const template = swymBarTemplate || window.__ffmSwymBarTemplate;
    if (template) {
      const bar = template.cloneNode(true);
      bar.setAttribute('data-ffm-swym-injected', 'true');
      return bar;
    }

    const bar = document.createElement('div');
    bar.className = 'swym-button-bar swym-wishlist-button-bar swym-inject';
    bar.setAttribute('data-ffm-swym-injected', 'true');
    bar.innerHTML = ''
      + '<div class="swym-btn-container swym-inject" data-position="default">'
      + '<button class="swym-button swym-add-to-wishlist swym-inject swym-iconbtnlink swym-heart swym-loaded"'
      + ' aria-label="' + swymAddLabel + '">'
      + '<span class="swym-wishlist-cta">' + swymAddCtaText + '</span>'
      + '</button>'
      + '</div>';
    return bar;
  }

  function ensureSwymWishlistButton(swat, product, variant) {
    if (isGiftProductPage()) return null;

    const productFormElement = getProductFormElement();
    if (!productFormElement) return null;

    const payload = buildProductPayload(product, variant);
    if (!payload) return null;

    let bar = findSwymButtonBar();

    if (!bar) {
      if (!window.__ffmProductContentSwapped) return null;
      bar = createSwymButtonBar();
      productFormElement.insertAdjacentElement('afterend', bar);
      bar.classList.add('moved');
    } else {
      moveSwymButtonBarOutsideForm();
    }

    bar.style.display = 'block';
    bar._ffmSwymProduct = payload;

    const btn = bar.querySelector('button');
    if (!btn) return bar;

    btn.setAttribute('data-variant-id', payload.epi);
    btn.setAttribute('data-product-id', payload.empi);
    btn.setAttribute('data-product-url', productPathFromUrl(payload.du));
    btn.classList.add('swym-loaded');
    btn.removeAttribute('onclick');

    if (bar.hasAttribute('data-ffm-swym-injected')) {
      wireWishlistButton();
    }

    if (swat?.initializeActionButtons && !bar.hasAttribute('data-ffm-swym-injected')) {
      try {
        swat.initializeActionButtons(PDP_SCOPE);
      } catch (_) {
        try { swat.initializeActionButtons('body'); } catch (_) {}
      }
    }

    checkWishlistState(swat, btn, payload);

    return bar;
  }

  function getSwymContextKey(product, variant) {
    const resolved = resolveVariant(product, variant);
    if (!resolved?.id) return '';
    return String(product?.id || '') + ':' + String(resolved.id);
  }

  function runSwymPass(swat, product, variant, force) {
    if (swymPassRunning) return;

    const contextKey = getSwymContextKey(product, variant);
    if (!force && contextKey && contextKey === lastSwymContextKey && findSwymButtonBar()) {
      moveSwymButtonBarOutsideForm();
      return;
    }

    swymPassRunning = true;
    if (mutationObserver) mutationObserver.disconnect();

    try {
      captureSwymBarTemplate();
      const resolvedVariant = resolveVariant(product, variant);
      if (!resolvedVariant?.id) return;

      updateSwymPageData(product, resolvedVariant);
      ensureSwymWishlistButton(swat, product, resolvedVariant);
      lastSwymContextKey = contextKey;
    } finally {
      swymPassRunning = false;
      bindSwymDomObserver();
    }
  }

  function withSwat(callback) {
    const swat = getSwat();
    if (swat) {
      callback(swat);
      return;
    }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function() { callback(getSwat()); });
  }

  function reinitializeSwymWishlist(options) {
    if (isGiftProductPage()) return;

    options = options || {};
    const force = Boolean(options.force);
    const product = options.product || window.globalSpace?.product || null;
    const variant = options.variant || product?.currentVariant || null;

    if (swymReinitTimer) clearTimeout(swymReinitTimer);

    const run = function() {
      withSwat(function(swat) {
        runSwymPass(swat, product, variant, force);
      });
    };

    run();

    swymReinitTimer = setTimeout(function() {
      withSwat(function(swat) {
        runSwymPass(
          swat,
          options.product || window.globalSpace?.product,
          options.variant || window.globalSpace?.product?.currentVariant,
          force
        );
      });
    }, 500);
  }

  window.ffm_reinitializeSwymWishlist = reinitializeSwymWishlist;

  function bindSwymDomObserver() {
    if (mutationObserver) mutationObserver.disconnect();

    const observeTarget = document.querySelector(MAIN_CONTENT) || document.querySelector('.product-form');
    if (!observeTarget) return;

    mutationObserver = new MutationObserver(function() {
      if (swymPassRunning) return;

      if (moveSwymButtonBarOutsideForm()) {
        captureSwymBarTemplate();
      }

      if (!window.__ffmProductContentSwapped) return;
      if (findSwymButtonBar()) return;

      withSwat(function(swat) {
        runSwymPass(swat, window.globalSpace?.product, window.globalSpace?.product?.currentVariant, true);
      });
    });

    mutationObserver.observe(observeTarget, { childList: true, subtree: true });
  }

  bindSwymDomObserver();
  bindInjectedWishlistClicks();
  startSwymPlacementWatcher();
  reinitializeSwymWishlist();

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function() {
    startSwymPlacementWatcher();
    moveSwymButtonBarOutsideForm();
  });

  document.addEventListener('product:content:updated', function(event) {
    const detail = event.detail || {};
    lastSwymContextKey = '';
    bindSwymDomObserver();
    startSwymPlacementWatcher();
    reinitializeSwymWishlist({
      variant: detail.variant,
      product: window.globalSpace?.product,
      force: true
    });
  });

  if (typeof eventBus !== 'undefined' && typeof THEME_EVENTS !== 'undefined') {
    eventBus.subscribe(THEME_EVENTS.variantChange, function(eventData) {
      reinitializeSwymWishlist({
        variant: eventData?.data?.variant,
        product: window.globalSpace?.product
      });
    });
  }

  document.addEventListener('variant:change', function(event) {
    const variantId = event.detail?.variantId || event.detail?.variant?.id;
    if (!variantId) return;
    reinitializeSwymWishlist({
      variant: { id: Number(variantId) },
      product: window.globalSpace?.product
    });
  });
})();

/**
 * Combined-listing only: remount Boost's native Back-In-Stock widget after
 * a sibling-product swap. Do not clone or restyle Boost's button — that
 * breaks the native popup. Regular PDPs (e.g. Rainbow Trout) are untouched.
 */
(function() {
  const BIS_BLOCK_ID = 'bc-bis';
  let remountTimer = null;

  function getFormVariantId() {
    return document.querySelector('#MainProductContent form[data-type="add-to-cart-form"] input[name="id"]')?.value
      || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value
      || '';
  }

  function resolveBisVariant(product, variant) {
    const formId = getFormVariantId();
    if (formId && product?.variants?.length) {
      const match = product.variants.find((item) => String(item.id) === String(formId));
      if (match) return match;
    }
    if (variant?.id && product?.variants?.length) {
      const match = product.variants.find((item) => String(item.id) === String(variant.id));
      if (match) return match;
    }
    if (product?.currentVariant) return product.currentVariant;
    return product?.variants?.[0] || variant || null;
  }

  function syncBoostSDProduct(product, variant) {
    if (!product) return;
    const currentVariant = resolveBisVariant(product, variant);
    if (currentVariant) product.currentVariant = currentVariant;
    if (!window.boostSDData) window.boostSDData = {};
    window.boostSDData.product = product;
    window.boostSDData.variant = currentVariant || null;
    window.boostSDData.selectedVariantId = currentVariant?.id || null;

    const settingsList = [
      window.boostWidgetIntegration?.generalSettings,
      window.boostWidgetIntegration?.config?.generalSettings,
      window.boostWidgetIntegration?.TAEApp?.config?.generalSettings
    ];
    settingsList.forEach(function(settings) {
      if (!settings) return;
      settings.product_id = String(product.id);
      if (currentVariant?.id) settings.variant_id = String(currentVariant.id);
      if (!settings.page) settings.page = 'product';
    });
    return currentVariant;
  }

  function isCombinedListingPdp() {
    if (window.__ffmProductContentSwapped) return true;
    const root = document.querySelector('#MainProductContent')
      || document.querySelector('.product-form-list')
      || document;
    return Boolean(
      root.querySelector('.combined-listing-option')
      || root.querySelector('variant-selects [data-product-url]:not([data-product-url=""])')
    );
  }

  function getBoostTaeApp() {
    return window.boostWidgetIntegration?.TAEApp || null;
  }

  function getBackInStockModule() {
    const taeApp = getBoostTaeApp();
    if (!taeApp) return null;
    const byName = taeApp.getModuleByName?.('BackInStock');
    if (byName) return byName;
    return (taeApp.modules || []).find(function(mod) {
      return mod.constructor?.moduleName === 'BackInStock';
    }) || null;
  }

  function patchControllerService(controller) {
    const service = controller?.backInStockService;
    if (!service || service.__ffmPatched) return;
    const original = service.updateBackInStockDisplay.bind(service);
    service.updateBackInStockDisplay = function(product, settings) {
      if (product && /^(PARENT|CHILD)$/i.test(String(product.combined_listing_role || ''))) {
        product = Object.assign({}, product);
        delete product.combined_listing_role;
      }
      return original(product, settings);
    };
    service.__ffmPatched = true;
  }

  function reregisterBisBlock() {
    const taeApp = getBoostTaeApp();
    if (!taeApp) return false;

    let block = taeApp.blocks?.[BIS_BLOCK_ID];
    if (!block) {
      const module = getBackInStockModule();
      if (module?.initBlock) {
        try { module.initBlock(); } catch (error) {}
      }
      return Boolean(taeApp.blocks?.[BIS_BLOCK_ID]);
    }

    delete taeApp.blocks[BIS_BLOCK_ID];
    if (window.boostWidgetIntegration?.blocks) delete window.boostWidgetIntegration.blocks[BIS_BLOCK_ID];
    try {
      taeApp.registerBlock(block);
      return true;
    } catch (error) {
      return false;
    }
  }

  function remountNativeBoost() {
    const target = document.querySelector('#MainProductContent .start_customizing')
      || document.querySelector('.start_customizing');
    if (!target) return false;

    const container = document.getElementById(BIS_BLOCK_ID);
    const controller = window.__ffmBoostBisController;
    if (controller && typeof controller.connect === 'function' && container) {
      patchControllerService(controller);
      try {
        const result = controller.connect({}, container);
        if (result && typeof result.then === 'function') result.catch(function() {});
        return true;
      } catch (error) {}
    }

    return reregisterBisBlock();
  }

  function reinitializeBoostBackInStock(options) {
    options = options || {};
    if (!options.force) return;
    if (!isCombinedListingPdp()) return;

    syncBoostSDProduct(options.product || window.globalSpace?.product, options.variant);

    if (remountTimer) clearTimeout(remountTimer);
    remountTimer = setTimeout(function() {
      remountNativeBoost();
    }, 150);
  }

  window.ffm_reinitializeBoostBackInStock = reinitializeBoostBackInStock;

  window.ffm_getBackInStockContext = function() {
    const product = window.globalSpace?.product || window.boostSDData?.product;
    const variant = resolveBisVariant(product, product?.currentVariant);
    return {
      product: product || null,
      variant: variant || null,
      productId: product?.id || null,
      variantId: variant?.id || null,
      available: Boolean(variant?.available)
    };
  };

  document.addEventListener('product:content:updated', function(event) {
    reinitializeBoostBackInStock({
      product: window.globalSpace?.product,
      variant: event.detail?.variant,
      force: true
    });
  });
})();
